import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { App } from 'antd'
import { brandModalConfirmProps } from '@/components/BrandButton'
import { useUploadStore } from '@/store'

export function hasActiveUpload(): boolean {
  return useUploadStore
    .getState()
    .tasks.some((x) => x.status === 'uploading' || x.status === 'parsing')
}

/**
 * 同一时间只有一份上传会话：开新的主包上传前，若还有包在传，先确认中断。
 */
export function useConfirmDropUploads() {
  const { t } = useTranslation()
  const { modal } = App.useApp()

  return useCallback(
    (proceed: () => void) => {
      if (!hasActiveUpload()) {
        proceed()
        return
      }
      modal.confirm({
        title: t('versionForm.closeWhileUploadingTitle'),
        content: t('versionForm.dropUploadsContent'),
        okText: t('versionForm.closeWhileUploadingOk'),
        cancelText: t('common.cancel'),
        ...brandModalConfirmProps('danger'),
        onOk: () => {
          useUploadStore.getState().clear()
          proceed()
        },
      })
    },
    [modal, t],
  )
}
